import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Card"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "card"
    }}>{`Card`}</h1>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { Card } from 'theme-ui'
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`<Card
  sx={{
    maxWidth: 256,
  }}>
  <Image src={images.nyc} />
  <Text>Card</Text>
</Card>
`}</code></pre>
    <h2 {...{
      "id": "variants"
    }}>{`Variants`}</h2>
    <p>{`Card style variants can be defined in the `}<inlineCode parentName="p">{`theme.cards`}</inlineCode>{` object.
By default the Card component uses the `}<inlineCode parentName="p">{`theme.cards.primary`}</inlineCode>{` variant.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// example theme variants
{
  cards: {
    primary: {
      padding: 2,
      borderRadius: 4,
      boxShadow: '0 0 8px rgba(0, 0, 0, 0.125)',
    },
    compact: {
      padding: 1,
      borderRadius: 2,
      border: '1px solid',
      borderColor: 'muted',
    },
  },
}
`}</code></pre>
    {
      /*
      '@comp/ui'
      */
    }

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      